// src/Pages/Admin/Zones/ZoneForm.tsx
import React, { useState, useEffect } from "react";
import { Zone } from "./types";
import "../Event/AdminEvent.css";

interface ZoneFormProps {
    zone: Zone | null;
    onSave: (zone: Zone) => void;
    onCancel: () => void;
}

const ZoneForm: React.FC<ZoneFormProps> = ({ zone, onSave, onCancel }) => {
    const [formData, setFormData] = useState<Zone>({
        zoneID: undefined,
        number: "",
        zoneName: "",
        created: "",
        updated: "",
    });

    useEffect(() => {
        if (zone) {
            setFormData(zone);
        } else {
            setFormData({
                zoneID: undefined,
                number: "",
                zoneName: "",
                created: "",
                updated: "",
            });
        }
    }, [zone]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.number || !formData.zoneName) return;
        onSave(formData);
    };

    return (
        <div className="eventform-page">
            <form className="eventform-card" onSubmit={handleSubmit}>
                <div className="eventform-header">
                    <h2 className="eventform-title">
                        {formData.zoneID ? "Opdater Zone" : "Opret Zone"}
                    </h2>
                    <p className="eventform-subtitle">
                        Opret eller redigér zoneoplysninger.
                    </p>
                </div>

                <div className="eventform-grid">
                    <div className="field">
                        <label>Zone nummer</label>
                        <input
                            type="text"
                            value={formData.number}
                            onChange={(e) =>
                                setFormData({ ...formData, number: e.target.value })
                            }
                            required
                        />
                    </div>

                    <div className="field">
                        <label>Zone navn</label>
                        <input
                            type="text"
                            value={formData.zoneName}
                            onChange={(e) =>
                                setFormData({ ...formData, zoneName: e.target.value })
                            }
                            required
                        />
                    </div>
                </div>

                <div className="eventform-divider" />

                <div className="eventform-actions">
                    <div />
                    <div className="actions-right">
                        <button type="submit" className="btn btn-primary">
                            Gem
                        </button>
                        <button
                            type="button"
                            className="btn btn-ghost"
                            onClick={onCancel}
                        >
                            Annuller
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ZoneForm;